<h1 mat-dialog-title class="pre-line p-2 text-center">{{message}}</h1>
<div>
  <mat-form-field *ngIf="data.withHashCheck" class="col">
    <input matInput [(ngModel)]="UserHash" placeholder="Confirmation">
  </mat-form-field>
  <button *ngIf="WithCancelButton" class="col-6 squared-flat-button" color="primary" mat-stroked-button (click)="onCancel()">
    Non
  </button>
  <button *ngIf="WithCancelButton" class="col-6 squared-flat-button" color="warn" mat-stroked-button (click)="onConfirm()" [disabled]="UserHash !== Hash">
    Oui
  </button>
  <button *ngIf="!WithCancelButton" class="col squared-flat-button" color="primary" mat-stroked-button (click)="onConfirm()">
    OK
  </button>
</div>